import ReviewCount from 'components/Product/ReviewCount/ReviewCount';

export default ReviewCount;
